import { Box, Container, Divider, Heading, SimpleGrid } from '@hover/blueprint';
import React, { useEffect, useState } from 'react';
import { nanoid } from 'nanoid';
import { HOW_HOVER_WORKS_LIST_DATA } from '../../../constants';
import HowHoverWorksHeader from './HowHoverWorksHeader';
import { Progress } from '../../ui';

interface Props {
  currentTab: number;
  resetTimer: (title: number) => void;
}

const HowItWorksDesktopTabs: React.FC<Props> = ({ currentTab, resetTimer }) => {
  const [mounted, setMounted] = useState<boolean>(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const selectTab = (tabNum: number) => {
    resetTimer(tabNum);
  };

  return (
    <Container centerContent maxW="1200px" d={{ base: 'none', tablet: 'flex' }}>
      <HowHoverWorksHeader />
      {HOW_HOVER_WORKS_LIST_DATA.map(listItem => (
        <Box
          key={listItem.title}
          d={listItem.id === currentTab ? 'flex' : 'none'}
          alignItems="center"
          justifyContent="center"
          w="100%"
          maxH="355px"
        >
          <Box maxH="355px" minH="355px" key={nanoid()}>
            {listItem.desktopImage}
          </Box>
        </Box>
      ))}
      <SimpleGrid columns={4} spacing={0} w="100%" mt={800}>
        {HOW_HOVER_WORKS_LIST_DATA.map(listItem => {
          const isCurrent = listItem.id === currentTab;
          return (
            <Box
              cursor="pointer"
              flexDir="column"
              key={listItem.id}
              onClick={() => selectTab(listItem.id)}
            >
              <Box
                bg={isCurrent ? 'red.100' : 'neutral.200'}
                mb={500}
                w={400}
                h={400}
                borderRadius="50%"
                alignItems="center"
                justifyContent="center"
              >
                <Heading
                  size={500}
                  marginBottom={0}
                  color={isCurrent ? 'red.500' : 'neutral.500'}
                >
                  {listItem.id + 1}
                </Heading>
              </Box>
              {isCurrent && mounted ? (
                <Progress barColor="red.500" />
              ) : (
                <Divider color="neutral.300" my={0} />
              )}
              <Heading
                maxW="90%"
                letterSpacing="1px"
                mt={800}
                size={200}
                marginBottom={400}
                color={isCurrent ? 'red.500' : 'neutral.500'}
              >
                {listItem.title}
              </Heading>
              <Heading
                maxW="90%"
                size={300}
                marginBottom={0}
                fontWeight={isCurrent ? 600 : 400}
                color={isCurrent ? 'neutral' : 'neutral.500'}
              >
                {listItem.body}
              </Heading>
            </Box>
          );
        })}
      </SimpleGrid>
    </Container>
  );
};

export default HowItWorksDesktopTabs;
